import styled from '@emotion/styled'
import { textMixin } from '../../../mixins/TextMixin/TextMixin'
import { breakpoint, calcRem, TheNightlyThemeConfig } from '../../../__styling'
import { tokens } from '@news-mono/design-tokens'
const { neutral } = tokens.thenightly.colors.palette

export const StyledSwingContainer = styled.div(({ theme }) => [
    {
        display: 'flex',
        flexDirection: 'column',
        gap: calcRem(16),
        width: '80%',
    },
])

export const StyledContentContainer = styled.div(({ theme }) => [
    {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'normal',
        gap: calcRem(16),

        // Tablet and above styling
        [breakpoint('sm')]: {
            gap: 0,
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
    },
])

type StyledLargeSwingTextProps = {
    textColor?: string
}
export const StyledLargeSwingText = styled.p<StyledLargeSwingTextProps>(
    ({ textColor = neutral[70], theme }) => [
        {
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            color: textColor,
            height: 'fit-content',

            strong: {
                // No token defined for this font, assuming one off
                fontFamily: theme.fonts.heading,
                fontSize: calcRem(64),
                fontWeight: 800,
                lineHeight: '100%',
                letterSpacing: '-1.92px',

                // Tablet and above styling
                [breakpoint('sm')]: {
                    fontSize: calcRem(80),
                    letterSpacing: '-2.4px',
                },
            },

            span: textMixin<TheNightlyThemeConfig>(theme, 'subheading'),
        },
    ],
)

export const StyledTextContainer = styled.div(({ theme }) => [
    {
        display: 'flex',
        flexDirection: 'column',
        gap: calcRem(16),
        width: '100%',

        // Tablet and above styling
        [breakpoint('sm')]: {
            width: '45%',
        },
    },
])

export const StyledChartContainer = styled.div(({ theme }) => [
    {
        maxHeight: calcRem(180),
        width: '100%',
        display: 'inline',

        // Tablet and above styling
        [breakpoint('sm')]: {
            display: 'flex',
            justifyContent: 'flex-end',
            flex: '1 1 45%',
        },
    },
])

export const StyledDisclaimerText = styled.p<{ type: 'mobile' | 'desktop' }>(
    ({ type, theme }) => [
        {
            margin: 0,
            color: neutral[70],
            display: type === 'mobile' ? 'block' : 'none',

            // Tablet and above styling
            [breakpoint('sm')]: {
                display: type === 'desktop' ? 'block' : 'none',
            },
        },
        textMixin<TheNightlyThemeConfig>(theme, 'body-alt'),
    ],
)
